import React from 'react';

const Tabs = ({ activeTab, setActiveTab, hidePersonalAccount, hideBusinessAccount }) => {
  return (
    <div
      className="tabs flex justify-center items-center mb-4 makeFlex textCenter latoBlack font16 capText noSelection"
      style={{ height: '50px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', borderRadius: '12px', overflow: 'hidden' }}
    >
      {!hidePersonalAccount && (
        <>
          <button
            className={`tab ${activeTab === 'user' ? 'active' : ''}`}
            onClick={() => setActiveTab('user')}
            data-acctype="User"
            style={{
              background: activeTab === 'user' ? 'linear-gradient(to right, #6a11cb, #2575fc)' : 'white',
              color: activeTab === 'user' ? 'white' : 'gray',
              borderColor: activeTab === 'user' ? '#2575fc' : 'transparent',
              borderRadius: '15px', // Rounded edges
              width: hideBusinessAccount ? '100%' : '200px', // Adjust width if Business Account is hidden
              height: '100%', // Full height of the strip
              transition: 'all 0.3s ease',
            }}
          >
            Personal Account
          </button>

          {/* Vertical line separator */}
          {!hideBusinessAccount && (
            <div
              style={{
                height: '50%', // Line height
                width: '1px', // Line width
                backgroundColor: '#d1d5db', // Light gray color
                margin: '0 10px', // Spacing between the buttons
              }}
            ></div>
          )}
        </>
      )}

      {!hideBusinessAccount && (
        <button
          className={`tab ml-0 ${activeTab === 'business' ? 'active' : ''}`}
          onClick={() => setActiveTab('business')}
          data-acctype="Business"
          style={{
            background: activeTab === 'business' ? 'linear-gradient(to right, #6a11cb, #2575fc)' : 'white',
            color: activeTab === 'business' ? 'white' : 'gray',
            borderColor: activeTab === 'business' ? '#2575fc' : 'transparent',
            borderRadius: '15px', // Rounded edges
            width: hidePersonalAccount ? '100%' : '200px', // Full width if Personal Account tab is hidden
            height: '100%', // Full height of the strip
            transition: 'all 0.3s ease',
          }}
        >
          Business Account
        </button>
      )}
    </div>
  );
};

export default Tabs;
